import { FC } from 'react';
import styled from '@emotion/styled';
import Typography from 'aquilla/core/atoms/Typography';
import { mediaQuery, Spacings } from '@styles/index';
import Image from '@base/Image';
import { getAnimationPath } from '@utils/animationHelpers';
import Dynamic from '@base/Dynamic/Dynamic';

const LottieAnimation = Dynamic(
  () => import('@base/LottieAnimation/LottieAnimation')
);
interface IGoalResultsProps {
  data: {
    header: string;
    results: {
      title: string;
      subTitle: string;
      description: string;
      webImage: string;
      mwebImage: string;
    }[];
  };
}

const trophyAnimations = [
  'trophy/Trophy-1.json',
  'trophy/Trophy-2.json',
  'trophy/Trophy-3.json'
];
const GoalResults: FC<IGoalResultsProps> = ({ data }) => {
  const results = data.results || [];

  return (
    <GoalResultsContainer>
      <GoalResultsTitleContainer>
        <GoalResultsTitle variant="h2">{data.header}</GoalResultsTitle>
      </GoalResultsTitleContainer>
      <GoalResultGrid>
        {results.map((item, index) => {
          const { title, subTitle, description, webImage, mwebImage } = item;
          return (
            <GoalResultItem key={String(index)}>
              <AnimationContainer
                // @ts-ignore
                src={getAnimationPath(trophyAnimations[index % 3])}
              />
              <GoalResultItemDiv>
                <GoalResultsItemText variant="h1">{title}</GoalResultsItemText>
                <GoalResultsItemText variant="h4">
                  {subTitle}
                </GoalResultsItemText>
                <GoalResultsItemText variant="h3">
                  {description}
                </GoalResultsItemText>
              </GoalResultItemDiv>
            </GoalResultItem>
          );
        })}
      </GoalResultGrid>
    </GoalResultsContainer>
  );
};

const GoalResultsTitleContainer = styled.div`
  display: flex;
  justify-content: center;

  ${mediaQuery.uptoMobile} {
    justify-content: flex-start;
  }
`;

const GoalResultsTitle = styled(Typography)``;

const GoalResultsItemText = styled(Typography)`
  color: var(--color-i-brown-2);
`;

const GoalResultItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoTablet} {
    margin-left: ${Spacings.SPACING_3B};
  }
`;

const GoalResultsContainer = styled.div`
  margin-top: ${Spacings.SPACING_12B};

  ${mediaQuery.uptoTablet} {
    margin-top: ${Spacings.SPACING_8B};
  }

  ${mediaQuery.uptoMobile} {
    margin-left: ${Spacings.SPACING_4B};
  }
`;

const GoalResultItem = styled.div`
  display: flex;
  justify-content: center;

  ${mediaQuery.uptoTablet} {
    justify-content: flex-start;
  }
`;

const GoalResultGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 33%);
  margin-top: ${Spacings.SPACING_15B};
  margin-bottom: ${Spacings.SPACING_18B};

  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(1, 100%);
    row-gap: ${Spacings.SPACING_8B};
    margin-top: ${Spacings.SPACING_6B};
    margin-bottom: ${Spacings.SPACING_8B};
  }
`;

const GoalResultItemImage = styled(Image)`
  height: 120px;
  width: 120px;

  ${mediaQuery.uptoMobile} {
    height: 88px;
    width: 88px;
  }
`;

const AnimationContainer = styled(LottieAnimation)`
  height: ${Spacings.SPACING_30B};
  width: ${Spacings.SPACING_30B};

  ${mediaQuery.uptoMobile} {
    height: ${Spacings.SPACING_22B};
    width: ${Spacings.SPACING_22B};
  }
`;

export default GoalResults;
